import {
  Question,
  RadioQuestion,
  SliderQuestion,
  TextQuestion
} from "../../types/questionTypes"
import { CheckboxField } from "./CheckboxField"
import { RadioField } from "./RadioField"
import { SliderField } from "./SliderField"
import { TextareaField } from "./TextareaField"
import { TextField } from "./TextField"

export interface RedcapFieldProps {
  question: Question
  value: string | string[]
  onChange: (newValue: string | string[]) => void
}

export default function RedcapField({
  value,
  question,
  onChange
}: RedcapFieldProps) {
  const { fieldType } = question

  const renderQuestion = () => {
    switch (fieldType) {
      case "radio":
        return (
          <RadioField
            value={value}
            question={question as RadioQuestion}
            onChange={onChange}
          />
        )
      case "checkbox":
        return (
          <CheckboxField
            value={value}
            question={question as RadioQuestion}
            onChange={onChange}
          />
        )
      case "text":
        return (
          <TextField
            value={value}
            question={question as TextQuestion}
            onChange={onChange}
          />
        )
      case "notes":
        return (
          <TextareaField
            value={value}
            question={question as TextQuestion}
            onChange={onChange}
          />
        )
      case "slider":
        return (
          <SliderField
            value={value}
            question={question as SliderQuestion}
            onChange={onChange}
          />
        )
      case "descriptive": // Descriptive has no field
      default:
        return null
    }
  }

  return renderQuestion()
}
